<div class="modal-body">
  <form [formGroup]="formFilter" (ngSubmit)="applyFilters()">

    <!-- Available Sites -->
    <ng-container *ngIf="canDisplayMultiSiteFilter()">
      <div class="form-group">
        <label>Sites</label>
        <ng-select
          [id]="'sites'"
          [placeholder]="''"
          [items]="availableSites"
          [multiple]="true"
          [formControl]="sites"></ng-select>
      </div>
    </ng-container>
    <!-- Available Sites -->

    <!-- RCA No Control -->
    <div class="form-group">
      <label for="rca-no">{{ getRCALabel() }}</label>
      <div class="input-group">
        <input
          id="rca-no"
          type="text"
          class="form-control input-rounded"
          [formControl]="rcaNo"
          [class.is-invalid]="failSearch['rn']"
          [ngbTypeahead]="searchRN"
          (click)="clicks$['rn'].next($any($event).target.value)"
          #rnInput
          #instanceRN="ngbTypeahead" />

        <div *ngIf="activeSearch['rn']" class="input-group-append-absolute">
          <div role="status" class="spinner-border text-light"><span class="sr-only">Loading...</span></div>
        </div>
        <div class="input-group-append-absolute p-0 input-group-append-right">
          <button *ngIf="!isRNFilled()" class="btn btn-outline-secondary" type="button" (click)="rnInput.click()">
            <i [ngClass]="['fa', 'fa-angle-down']"></i>
          </button>
          <button *ngIf="isRNFilled()" class="btn btn-outline-secondary" type="button" (click)="resetRN(rnInput)">
            <i [ngClass]="['fa', 'fa-times']"></i>
          </button>
        </div>
      </div>
      <div *ngIf="rcaNo.errors && (rcaNo.dirty || rcaNo.touched)">
        <div *ngIf="rcaNo.errors.pattern" class="invalid-feedback force-show">
          RCAF No could only contain letters [A-Z], numbers [0-9] and signs like <b>*</b> <b>_</b> <b>-</b> <b>.</b> <b>:</b>
        </div>
        <div *ngIf="rcaNo.errors.invalidStringForPattern" class="invalid-feedback force-show">
          RCAF No could not contain 2 consecutive * sign
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="failSearch['rn']">Sorry, suggestions could not be loaded.</div>
    </div>
    <!-- RCA No Control -->

    <!-- TagName Control -->
    <div class="form-group">
      <label for="tagName">Tagname</label>
      <div class="input-group">
        <input
          id="tagName"
          type="text"
          class="form-control input-rounded"
          [formControl]="tagName"
          [class.is-invalid]="failSearch['tn']"
          [ngbTypeahead]="searchTN"
          (click)="clicks$['tn'].next($any($event).target.value)"
          #tagNameInput
          #instanceTN="ngbTypeahead" />

        <div *ngIf="activeSearch['tn']" class="input-group-append-absolute">
          <div role="status" class="spinner-border text-light"><span class="sr-only">Loading...</span></div>
        </div>
        <div class="input-group-append-absolute p-0 input-group-append-right">
          <button *ngIf="!isTNFilled()" class="btn btn-outline-secondary" type="button" (click)="tagNameInput.click()">
            <i [ngClass]="['fa', 'fa-angle-down']"></i>
          </button>
          <button *ngIf="isTNFilled()" class="btn btn-outline-secondary" type="button" (click)="resetTN(tagNameInput)">
            <i [ngClass]="['fa', 'fa-times']"></i>
          </button>
        </div>
      </div>
      <div *ngIf="tagName.errors && (tagName.dirty || tagName.touched)">
        <div *ngIf="tagName.errors.pattern" class="invalid-feedback force-show">
          Tagname could only contain letters [A-Z], numbers [0-9] and signs like <b>*</b> <b>_</b> <b>-</b> <b>.</b> <b>:</b>
        </div>
        <div *ngIf="tagName.errors.invalidStringForPattern" class="invalid-feedback force-show">
          Tagname could not contain 2 consecutive * sign
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="failSearch['tn']">Sorry, suggestions could not be loaded.</div>
    </div>
    <!-- TagName Control -->

    <!-- Title Control -->
    <div class="form-group">
      <label for="title">Title</label>
      <input type="text" class="form-control" [formControl]="title" id="title"/>

      <div *ngIf="title.errors && (title.dirty || title.touched)">
        <div *ngIf="title.errors.invalidStringForPattern" class="invalid-feedback force-show">
          Title could not contain 2 consecutive * sign
        </div>
      </div>
    </div>
    <!-- Title Control -->

    <div *ngIf="formFilter.errors">
      <div *ngIf="formFilter.errors?.invalidCount" class="mb-1 mb-3 invalid-feedback force-show">
        No filter selected.
      </div>
    </div>

    <div class="form-group">
      <button
        type="submit"
        class="btn btn-info me-auto btn-filter"
        [disabled]="formFilter.invalid">Apply</button>
    </div>
  </form>
</div>
